import CoursesListPageContainer from "../../components/courses/coursesList";

const CoursesList = () => {
  return <CoursesListPageContainer />;
};
export default CoursesList;
